export default __webpack_public_path__ + "static/media/landingInfographic1.945038fc.png";